import styled from "styled-components";

export const PictureBalanceRechargeContainer = styled.div``;
